import { BulkImportType } from '../formSteps/FileSelection/hooks';
import { BulkFilesUploadForm, BulkImportFormData, StepFlow } from '../types';
import { useBulkDRMEntityImportStepFlow } from './useBulkDRMEntityImportStepFlow';
import { useBulkFileImportStepFlow } from './useBulkFileImportStepFlow';

type UseBulkImportStepFlowsProps = {
  bulkImportType: BulkImportType;
  onBulkImportTypeChange: (fileImporType?: BulkImportType) => void;
};

type UseBulkImportStepFlowReturn =
  | StepFlow<BulkImportFormData>
  | StepFlow<BulkFilesUploadForm>;

export function useBulkImportStepFlow({
  bulkImportType,
  onBulkImportTypeChange,
}: UseBulkImportStepFlowsProps): UseBulkImportStepFlowReturn {
  const bulkDRMEntityImportStepFlow = useBulkDRMEntityImportStepFlow({
    bulkImportType,
    onBulkImportTypeChange,
  });
  const bulkFileImportStepFlow = useBulkFileImportStepFlow({
    bulkImportType,
    onBulkImportTypeChange,
  });

  switch (bulkImportType) {
    case BulkImportType.DATA_VENDOR:
    case BulkImportType.DATASET:
    case BulkImportType.CONTACT:
      return bulkDRMEntityImportStepFlow;

    case BulkImportType.FILE:
      return bulkFileImportStepFlow;

    default:
      return bulkDRMEntityImportStepFlow;
  }
}
